/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Pagination } from '../models/Pagination';
import { UnifiedDBRecord } from '../models/UnifiedDBRecord';

export class SearchDBResponse {
  'data': Array<UnifiedDBRecord>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "data",
      "baseName": "data",
      "type": "Array<UnifiedDBRecord>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SearchDBResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

